module.exports = __webpack_public_path__ + "static/media/ThumbnailStill15.a354b58a.png";